import Util from './Util.js';

const dataParams = Util.getParamsFormScript('monitorJs', 'data-params') || {};

let P = {
    getPerformance() {
        let timing = window.performance.timing;
        return timing;
    },
    setData() {
        let timing = this.getPerformance();
        let startTime = timing.navigationStart || timing.fetchStart;
        let data = {
            eventId: Util.uuid(),
            eventType: 'h5_performance',
            baseTime: {
              wst: this.getFirstPaintTime(),
              fcp: this.getFCPTime(),
              FMP_API: '',
              FMP_DOM: '',
              FMP: '',
              it: timing.domInteractive - startTime,
              lt: timing.loadEventEnd && (timing.loadEventEnd - startTime) > 0 ? (timing.loadEventEnd - startTime) : 0
            },
            buildType: Util.getUseragentKey().buildType,
            url: window.location.href
        };
        
        Util.filterInvalidProps(data.baseTime);
        return data;
    },
    // 获取FCP时间
    getFCPTime() {
        let fcp = 0
        const perf = window.performance;
        if (perf && perf.getEntriesByType) {
            // 获取H5白屏的指标first-paint
            const entries = perf.getEntriesByType('paint');
            if (Array.isArray(entries)) {
                const type = 'first-contentful-paint';
                const entry = entries.find(e => e.name === type)
                if (entry) {
                    return Math.round(entry.startTime)
                }
            }
        }
        return fcp;
    },
    // 获取FMP时间
    getFMPTime() {
        const ssrFlag = window.__USE_SSR__;
        let fmp = 0;
        const perf = window.performance;
        const start = perf.timeOrigin || perf.timing.navigationStart || perf.timing.fetchStart;

        // SSR情况下，取DOMContentLoaded耗时
        if (ssrFlag === true) {
            fmp = Math.round(perf.timing.domContentLoadedEventEnd - start);
        } else {
            let serialTime = 0;
            const ajaxResources = perf.getEntriesByType('resource').filter(e => e.initiatorType === 'xmlhttprequest');
            if (dataParams.serialApis) {
                const apiNames = dataParams.serialApis.split(',');
                apiNames.forEach(apiName => {
                    const perf = ajaxResources.find(a => a.name.indexOf(apiName) !== -1);
                    if (perf) {
                        if (perf.responseEnd > serialTime) {
                            serialTime = perf.responseEnd;
                        }
                    }
                });
            }
            const maxInParallelTime = Math.max(...ajaxResources.map(e => e.responseEnd));
            fmp = Math.round(Math.max(serialTime, maxInParallelTime));
        }
        return fmp;
    },
    //获取首次渲染时间
    getFirstPaintTime() {
        var firstPaintTime = 0;
        // 优先使用Paint Timing API计算H5白屏时间
        const perf = window.performance;
        if (perf && perf.getEntriesByType) {
            // 获取H5白屏的指标first-paint
            const type = 'first-paint';
            const entries = perf.getEntriesByType('paint');
            if (Array.isArray(entries)) {
                const entry = entries.find(e => e.name === type);
                if (entry) {
                    return Math.round(entry.startTime);
                }
            }
        }

        let timing = window.performance.timing;
        if (window.chrome && window.chrome.loadTimes && window.chrome.loadTimes().firstPaintTime) { //Chrome
            firstPaintTime = window.chrome.loadTimes().firstPaintTime * 1000 - timing.navigationStart;
        } else { //IE, safari
            if (window.location.protocol.indexOf('ppdhttp') > -1) {
                // 离线包
                firstPaintTime = timing.domContentLoadedEventEnd - timing.navigationStart;
            } else {
                // 非离线包
                // 找到head里面的js，css下载时间最长的
                // firstPaintTime = timing.domLoading - timing.navigationStart
                firstPaintTime = this.findHeadLastTiming();
            }
        }
        return Math.round(firstPaintTime);
    },

    // 找到 head 里面加载时间最长的资源时间， 即白屏时间
    findHeadLastTiming() {
        let resourceTotalTimingObj = this.getTotalResource();
        let resourceHead = this.getHeadResource();
        let timeWst = 0;
        resourceHead.forEach(item => {
            if(timeWst < resourceTotalTimingObj[item]) {
                timeWst = resourceTotalTimingObj[item];
            }
        })
        return timeWst;
    },

    // 缓存页面的所有的资源
    getTotalResource() {
        const entries = window.performance.getEntries(), len = entries.length;
        let resourceTotalTimingObj = {};
        for(let i = 0; i < len; i++) {
            const item = entries[i];
            const itemName = item.name;
            resourceTotalTimingObj[itemName] = item.responseEnd;
        }
        return resourceTotalTimingObj;
    },

    // 找到head里面的所有的资源
    getHeadResource() {
        const linkArr = document.head.querySelectorAll('link'); // href
        const jsArr = document.head.querySelectorAll('script'); // src
        let _linkArr = Array.from(linkArr);
        let _jsArr = Array.from(jsArr);
        _linkArr = _linkArr.map(item => {
            return item.href;
        });
        _jsArr = _jsArr.map(item => {
            return item.src;
        });
        return [..._linkArr, ...jsArr];
    },

    // 获取所有的静态资源个数
    getResourceStatic() {
        let jsArr = document.querySelectorAll('script');
        jsArr = Array.from(jsArr);
        let jsLength = 0;
        jsArr.forEach(item => {
            if(item.src) {
                jsLength ++;
            }
        });
        let imgArr = Array.from(document.querySelectorAll('img'));
        let imgLength = 0;
        imgArr.forEach(item => {
            if(item.src && !item.src.includes('data:image')) {
                imgLength ++;
            }
        });
        let linkArr = document.querySelectorAll('link'); // href
        let linkLength = 0;
        linkArr = Array.from(linkArr);
        linkArr.forEach(item => {
            if(item.href && item.rel === 'stylesheet') {
                linkLength++;
            }
        });
        return jsLength + imgLength + linkLength + 1; // 主文档1
    },

    // 找到字体文件的个数
    findFontCount() {
        const resources = this.getTotalResource();
        let count = 0;
        for(const prop in resources) {
            prop.includes('/res/font') && count++;
        }
        return count;
    },

    // 找到当前时间
    getCurrentToStart() {
        let timing = window.performance.timing;
        let t = new Date().getTime();
        return t - timing.fetchStart;
    },

    // 获取首屏时间,超时时间timeout(毫秒)
    getFirstScreenTime(timeout) {
        const details = [];
        const ignoreEleList = ['script', 'style', 'link', 'br'];
        return new Promise(function (resolve, reject) {
            // timeout ms之内先收集所有的dom变化，并以key（时间戳）、value（dom list）的结构存起来。
            let observeDom = new MutationObserver(function (mutations) {
                if (!mutations || !mutations.forEach)
                    return;
                let detail = {
                    time: performance.now(),
                    roots: []
                };
                mutations.forEach(function (mutation) {
                    if (!mutation || !mutation.addedNodes || !mutation.addedNodes.forEach)
                        return;
                    mutation.addedNodes.forEach(function (ele) {
                        if (ele.nodeType === 1 && ignoreEleList.indexOf(ele.nodeName.toLocaleLowerCase()) === -1) {
                            if (!Util.isEleInArray(ele, detail.roots)) {
                                detail.roots.push(ele);
                            }
                        }
                    });
                });
                if (detail.roots.length) {
                    details.push(detail);
                }
            });
            observeDom.observe(document, {
                childList: true,
                subtree: true
            });
            setTimeout(function () {
                observeDom.disconnect();
                resolve(details);
            }, timeout);
        }).then(function (details) {
            // 分析上面收集到的数据，返回最终的结果
            let firstScreenTime = 0;
            let detail = details[details.length -1];
            // 取added node里的首屏内元素作为来找首屏渲染的最后DOM
            details.forEach(function (detail) {
                for (let i = 0; i < detail.roots.length; i++) {
                    // 一旦整个roots中有一个元素在首屏内，就可以拿这次的时间作为首屏DOM载入之间
                    if (Util.isInFirstScreen(detail.roots[i])) {
                        firstScreenTime = detail.time;
                        break;
                    }
                }
            });
            // 所以dom渲染时间和图片返回时间中大的为首屏渲染时间
            const resourceList = window.performance.getEntriesByType('resource');
            resourceList.forEach(function (resource) {
                // 首屏时间，在最后的Dom加入document前发起请求的图片的最后响应时间
                if (resource.initiatorType === 'img' && (resource.fetchStart < firstScreenTime || resource.startTime < firstScreenTime) && resource.responseEnd > firstScreenTime) {
                  firstScreenTime = resource.responseEnd;
                }
                
            });
            return {
              firstScreenTime: Math.round(firstScreenTime)
            };
        });
    }
};

export const getFMP = P.getFMPTime;

export default P;